import { Card, Table, Button, Spinner, Badge } from 'react-bootstrap';
import { ArrowUp, ArrowDown } from 'lucide-react';
import type { PointTransaction } from '../../../../infrastructure/LoyaltyClient';

interface TransactionHistoryProps {
  transactions: PointTransaction[];
  isLoading: boolean;
  hasMore?: boolean;
  onLoadMore: () => void;
}

export const TransactionHistory = ({ transactions, isLoading, hasMore, onLoadMore }: TransactionHistoryProps) => {
  if (isLoading) {
    return (
      <Card className="mb-4">
        <Card.Body className="text-center">
          <Spinner animation="border" />
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="mb-4">
      <Card.Body>
        <Card.Title>Transaction History</Card.Title>
        {transactions.length === 0 ? (
          <p className="text-muted">No transactions found</p>
        ) : (
          <>
            <Table striped hover responsive>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Points</th>
                  <th>Activity</th>
                  <th>Order ID</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((transaction) => (
                  <tr key={transaction.transactionId}>
                    <td>{new Date(transaction.timestamp).toLocaleString()}</td>
                    <td>
                      {transaction.pointsDelta > 0 ? (
                        <Badge bg="success">
                          <ArrowUp size={14} className="me-1" />
                          Earn
                        </Badge>
                      ) : (
                        <Badge bg="warning">
                          <ArrowDown size={14} className="me-1" />
                          Redeem
                        </Badge>
                      )}
                    </td>
                    <td className={transaction.pointsDelta > 0 ? 'text-success' : 'text-warning'}>
                      {transaction.pointsDelta > 0 ? '+' : ''}
                      {transaction.pointsDelta?.toLocaleString() || '0'}
                    </td>
                    <td>{transaction.activityType || '-'}</td>
                    <td>{transaction.orderId || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {hasMore && (
              <div className="text-center">
                <Button variant="outline-primary" onClick={onLoadMore}>
                  Load More
                </Button>
              </div>
            )}
          </>
        )}
      </Card.Body>
    </Card>
  );
};
